import { render, staticRenderFns } from "./MenuItemInfoPopup.vue?vue&type=template&id=aa8c0308&scoped=true&"
import script from "./MenuItemInfoPopup.vue?vue&type=script&lang=js&"
export * from "./MenuItemInfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemInfoPopup.vue?vue&type=style&index=0&id=aa8c0308&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8c0308",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDialog,VRow})
